// 获取Api url
export function getApiUrl() {
  return process.env.VUE_APP_API_URL
}
// 获取后台 请求域名
export function getBaseUrl() {
  return process.env.VUE_APP_BASE_URL
}
// 高拍仪的WEBSocket地址
export function getCaramaSocketUrl () {
  return 'ws://127.0.0.1:12345'
}
// 身份证读卡器webUrl地址
export function getReadIdCardUrl () {
  return 'http://127.0.0.1:8080/api/ReadMsg'
}
// 获取网易云信的配置
export function getNIMConfig () {
  let config = {
    appkey: 'dbd3ea8ca7eecac2a49cb919c3d67e23',
    postUrl: 'https://app.netease.im',
    localMsglimit: 100, //拉取消息的条数
    vaildTime: 60
  }
  if (process.env.NODE_ENV === 'production') {
    config = {
      appkey: 'dbd3ea8ca7eecac2a49cb919c3d67e23',
      postUrl: 'https://app.netease.im',
      localMsglimit: 100
    }
  }
  return config
}
// 获取在线阅片地址
export function getOnlineFilmViewUrl () {
  return process.env.VUE_APP_BASE_URL + '/viewImage/index.html'
}

// 获取AI医院名称
export function getAiCheckImageCenterId() {
  return process.env.VUE_APP_AI_CENTER_ID
}

// 获取上传影像的地址
export function getUploadImageBaseUrl() {
  return process.env.VUE_APP_UPLOAD_IMAGE_URL
}

export function getAllHeaderMenuUrl () {
  const menuUrls = [
    'ris/queue',
    'ris/callNum',
    'ris/editReportList',
    'ris/monitorStatistical',
    'ris/evaluate',
    'ris/historyCheck',
    'ris/appointmentCheck',
    'ris/reception',
    'ris/screening'
  ]
  return menuUrls
}

